export enum PermissionResource {
    'txa' = 'txa',
    'statuspage' = 'statuspage',
    'invoice' = 'invoice'
}